import { Fragment, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import IconButton from "../UI/IconButton/IconButton";
import FilterTab from "../UI/FilterTab/FilterTab";
import Table from "./Table/Table";
import BookTable from "./BookTable/BookTable";
import { selectTable } from "../../redux/finalOrder";
import classes from "./Zones.module.scss";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const TABLES = [
  {
    id: "#55685",
    size: 4,
    tableNum: "T58",
    status: "Reserved",
    shape: "round",
  },
  {
    id: "#52555",
    size: 6,
    tableNum: "T58",
    status: "Available",
  },
  {
    id: "#56785",
    size: 4,
    tableNum: "T58",
    status: "Disabled",
    shape: "round",
  },
  {
    id: "#52585",
    size: 12,
    tableNum: "T58",
    status: "Occupied",
  },
  {
    id: "#59385",
    size: 6,
    tableNum: "T58",
    status: "Occupied",
  },
  {
    id: "#50985",
    size: 8,
    tableNum: "T58",
    status: "Available",
    shape: "round",
  },
];

const DISHES = ["ALL_TABLES", "VACANT", "OCCUPIED", "DISABLED", "RESERVED"];
// const DISHES = ["All tables", "Vacant", "Occupied", "Disabled", "Reserved"];

const Zones = () => {
  const { t } = useTranslation();
  const { selectedTable } = useSelector((state) => state.finalOrder);
  const dispatch = useDispatch();
  let [searchParams] = useSearchParams();
  const group = new URLSearchParams(searchParams).get("groupOf");
  const [tableFilter, setTableFilter] = useState("ALL_TABLES");

  const onChangeFilter = (newValue) => {
    setTableFilter(newValue);
  };

  const getFilteredTables = () => {
    let filteredTables = TABLES;

    if (group) {
      let sizes = group.split("-");
      filteredTables = filteredTables.filter((table) => {
        return (
          table.size >= parseInt(sizes[0]) && table.size <= parseInt(sizes[1])
        );
      });
    }
    if (tableFilter === "ALL_TABLES") {
      return filteredTables;
    }
    return filteredTables.filter((table) => {
      if (tableFilter === "VACANT") {
        return table.status === "Available";
      }
      return table.status === tableFilter;
    });
  };

  const selectTableHandler = (id, tableNum) => {
    dispatch(selectTable({ id, tableNum }));
  };

  return (
    <Fragment>
      <div className={classes.FilterTab}>
        <FilterTab
          group="dishes"
          options={DISHES}
          selectedOption={tableFilter}
          onChangeFilter={onChangeFilter}
        />
        <IconButton
          icon="squares"
          iconPosition="left"
          text={t("BTN_SELECT_TABLE")}
          onClicked={() => console.log("Add service")}
        />
      </div>
      <h2 className={classes.Heading2}>{t("ZONE")} 1 - Gathering Lounge</h2>
      <div className={classes.Tables}>
        {getFilteredTables().map((table) => {
          return (
            <Table
              key={Math.random(100)}
              id={table.id}
              size={table.size}
              tableNum={table.tableNum}
              status={table.status}
              shape={table.shape}
              isSelected={selectedTable.id === table.id}
              onClicked={selectTableHandler}
            />
          );
        })}
      </div>
      <BookTable />
    </Fragment>
  );
};

export default Zones;
